export enum ErrorCodes {
  UserRejection,
  UnknownError,
}
